import {
  Box,
  Button,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useState } from "react";
import {
  getAllBills,
  getImportItemById,
  updateImportBillPayments,
} from "../../../services/Import";
import AutoCompleteFeild from "../../../FormComponents/AutoCompleteFeild";
import InputField from "../../../FormComponents/InputField";
import { getUser } from "../../../Utils/Common";
import BillWritableTable from "../../../components/BillWritableTable";
import FormAlert from "../../../components/FormAlert";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import SyncIcon from "@mui/icons-material/Sync";
import ItemSelectingPopup from "../../../components/ItemSelectingPopup";
import Validation from "../../../Validation/ImportBillValidation";
import Im_billConfirmation from "./Im_billConfirmation";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import RedoIcon from "@mui/icons-material/Redo";
import PaymentOptions from "../../../components/PaymentOptions";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // height: 400,
  bgcolor: "background.paper",
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

function Im_addBill({ setOpenForm }) {
  //load shop names
  const getShopNames = async () => {
    let bill_list = await getAllBills();
    setBills(bill_list);
  };

  //for input feild values
  const [values, setValues] = useState({
    _billNo: "",
    _shop: "",
    _discount: 0.0,
    _total: 0.0,
    _billNote: "",
    _payment: "",
  });

  //Reset values
  const resetValues = () => {
    closeAlert();
    setSelectedItems([]);
    setValues({
      _billNo: "",
      _shop: "",
      _discount: 0.0,
      _total: 0.0,
      _billNote: "",
      _payment: "",
    });
  };

  // Alerts ////////////////////////////////////

  //display alert...
  const [displayAlert, setAlert] = useState(false);

  //alert data
  const [alertData, setAlertData] = useState({
    type: "",
    message: "",
  });

  const closeAlert = () => {
    setAlert(false);
    setAlertData({
      type: "",
      message: "",
    });
  };

  //////////////////////////////////////////////

  //dataset for bills
  const [bills, setBills] = useState([]);

  // set open table
  const [openTable, setOpenTable] = useState(false);

  // errors for inputfeild
  const [error, setError] = useState({});

  const handleChange = (name, val) => {
    setValues({
      ...values,
      [name]: val,
    });
  };

  //columns for selected table for intake bill
  const selectedColumnsForIntake = [
    { id: "item", label: "Item", minWidth: 100, editable: false },
    { id: "brand", label: "Brand", minWidth: 100, editable: false },
    {
      id: "qty",
      label: "Qty",
      minWidth: 100,
      editable: true,
      type: "number",
      isDecimal: false,
    },
    { id: "billUnit", label: "Bill Unit", minWidth: 100, editable: true },
    { id: "unitType", label: "Unit", minWidth: 100, editable: false },
    {
      id: "itemUintsPerBillUnit",
      label: "Item Units per Bill Unit",
      minWidth: 140,
      editable: true,
      type: "number",
      isDecimal: true,
      info: {
        title: "Item Units per Bill Unit",
        description:
          "How many individual stock/item units (e.g. Pieces, Kg) are contained in ONE Bill Unit (e.g. Box, Carton). " +
          "This conversion factor is used to translate the quantity you're billed for into the actual stock quantity added to inventory, and to work out the true per-unit cost of the item.",
        formula:
          "Stock Qty Added = Qty × Item Units per Bill Unit\n" +
          "Unit Price = Price ÷ (Qty × Item Units per Bill Unit)",
        example:
          "Example: Bill Unit = \"Box\", 1 Box contains 24 pcs → Item Units per Bill Unit = 24\n\n" +
          "Buying Qty = 5 Boxes for a total Price of Rs. 1200:\n" +
          "• Stock increases by 5 × 24 = 120 pcs\n" +
          "• Unit Price = 1200 ÷ (5 × 24) = Rs. 10.00 per pc",
      },
    },
    {
      id: "unitPrice",
      label: "Unit Price",
      minWidth: 140,
      editable: true,
      type: "number",
      isDecimal: true,
    },
    {
      id: "discountPerItem",
      label: "Discount",
      minWidth: 140,
      editable: true,
      type: "number",
      isDecimal: true,
    },
    {
      id: "price",
      label: "Price",
      minWidth: 140,
      editable: true,
      type: "number",
      isDecimal: true,
    },
    {
      id: "updatePrice",
      label: "Update Price",
      minWidth: 100,
      editable: true,
      type: "checkbox",
    },
  ];

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [openConfimation, setOpenConfirmation] = React.useState(false);
  const [billData, setBillData] = React.useState({});
  const [selectedDate, setSelectedDate] = useState(null);
  const [billDate, setBillDate] = useState(null);

  //just hard coded...
  const [writeable_page, set_writeable_Page] = React.useState(0);
  const [writeable_rowsPerPage, set_writeable_RowsPerPage] =
    React.useState(100);

  // const [payment, setPayment] = React.useState("");
  const [paymentMethods, setPaymentMethods] = useState([]);


  const handleOpenTable = async () => {
    setOpenTable(true);
  };

  const handleCloseTable = async () => {
    setOpenTable(false);
    const selectedArray = [];
    for (let x = 0; x < selectedItems.length; x++) {
      let importItem = await getImportItemById(selectedItems[x]);
      selectedArray.push(
        createDataForSelectedTable(
          importItem.itemName + "(" + importItem.product_code + ")",
          importItem.brand,
          0.0,
          importItem.unitType,
          importItem.unitType,
          1,
          0.0,
          0.0,
          0.0,
          true,
          importItem.importId,
          importItem.qty
        )
      );
    }
    setSelectedRows(selectedArray);
  };

  function createDataForSelectedTable(
    item,
    brand,
    qty,
    billUnit,
    unitType,
    itemUintsPerBillUnit,
    unitPrice,
    discountPerItem,
    price,
    updatePrice,
    importId,
    existingQty
  ) {
    return {
      item,
      brand,
      qty,
      billUnit,
      unitType,
      itemUintsPerBillUnit,
      unitPrice,
      discountPerItem,
      price,
      updatePrice,
      importId,
      existingQty,
    };
  }


  const priceDiscountOperations = () => {
    const billRows = [...selectedRows];
    let _totalPrice = 0.0;
    let errors = {};

    for (let x = 0; x < billRows.length; x++) {
      const row = billRows[x];

      const qty = parseFloat(row.qty) || 0;
      const unitPrice = parseFloat(row.unitPrice) || 0;
      const price = parseFloat(row.price) || 0;
      const discountPerItem = parseFloat(row.discountPerItem) || 0;

      if (qty <= 0) continue;

      // Case 1: derive total price from unit price
      if (qty > 0 && unitPrice > 0) {
        const calculatedPrice = parseFloat((qty * unitPrice - discountPerItem).toFixed(2));
        if (calculatedPrice < 0) {
          errors[`row_${x}`] = "Discount cannot be greater than total price";
          billRows[x] = { ...row, price: 0 };
        } else {
          billRows[x] = { ...row, price: calculatedPrice };
          _totalPrice = parseFloat((_totalPrice + calculatedPrice).toFixed(2));
        }
      }
      // Case 2: derive unit price from total price
      else if (qty > 0 && price > 0) {
        const calculatedUnitPrice = parseFloat(
          ((price + discountPerItem) / qty).toFixed(2)
        );
        if (calculatedUnitPrice < 0) {
          errors[`row_${x}`] = "Unit price calculation resulted in negative value";
          billRows[x] = { ...row, unitPrice: 0 };
        } else {
          billRows[x] = { ...row, unitPrice: calculatedUnitPrice };
          _totalPrice = parseFloat((_totalPrice + price).toFixed(2));
        }
      }
      // Case 3: price already present with no unit price to recalculate
      else if (price > 0) {
        _totalPrice = parseFloat((_totalPrice + price).toFixed(2));
      }
    }

    setSelectedRows(billRows);

    const finalTotal = parseFloat(
      (_totalPrice - parseFloat(values._discount || 0)).toFixed(2)
    );
    setValues({
      ...values,
      _total: finalTotal,
    });

    if (Object.keys(errors).length > 0) {
      setAlert(true);
      setAlertData({
        type: "error",
        message: "Some calculations resulted in invalid values. Please check your inputs.",
      });
    } else {
      closeAlert();
    }
  };

  const submitValue = async () => {
    if (selectedRows) {
      let user = getUser();
      const billBody = {
        addedBy: user.username,
        billNo: values._billNo,
        shop: values._shop,
        note: values._billNote,
        total: values._total,
        discount: values._discount,
        billDate: billDate,
        billType: "INTAKE BILL",
        import_billItems: selectedRows,
      };

      const validationErrors = Validation(billBody, selectedRows);
      setError(validationErrors);

      if (Object.keys(validationErrors).length === 0) {
        setBillData(billBody);
        setOpenConfirmation(true);
      }
    }
  };

  return openConfimation ? (
    <Im_billConfirmation
      billData={billData}
      setOpenConfirmation={setOpenConfirmation}
      payments={paymentMethods}
    />
  ) : (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={11} sx={12}>
        <Typography mt={1} variant="h6">
          {" "}
          Add Import Bill{" "}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={1} sx={12}>
        <Tooltip title="Close">
          <IconButton
            onClick={() => {
              setOpenForm(false);
            }}
            aria-label="close"
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Grid>
      <Grid item xs={12} sm={4} sx={12}>
        <InputField
          name="_billNo"
          errorMsg={error._billNo}
          value={values._billNo}
          onChange={(event, newInputValue) =>
            handleChange(event, newInputValue)
          }
          type="text"
          label="Bill Number"
        />
      </Grid>
      <Grid item xs={12} sm={9} sx={12}>
        <AutoCompleteFeild
          _key="shop"
          name="_shop"
          value={values._shop}
          dataSet={bills}
          label="Shop"
          onClick={getShopNames}
          errorMsg={error._shop}
          onchange={(event, newInputValue) =>
            handleChange(event, newInputValue)
          }
        />
      </Grid>
      <Grid item xs={12} sm={4} sx={12}>
        <Button onClick={handleOpenTable} variant="outlined">
          Select Item
        </Button>
      </Grid>
      <Grid item xs={12} sm={12} sx={12}>
        {/* selected table */}
        {selectedItems.length !== 0 ? (
          <BillWritableTable
            columns={selectedColumnsForIntake}
            rows={selectedRows}
            setRows={setSelectedRows}
            page={writeable_page}
            setPage={set_writeable_Page}
            rowsPerPage={writeable_rowsPerPage}
            tablePagin={false}
            setRowsPerPage={set_writeable_RowsPerPage}
          />
        ) : null}
      </Grid>
      {error._items ? (
        <Grid item xs={12} sm={12} sx={12}>
          <Typography
            align="left"
            variant="caption"
            style={{
              color: "red",
              fontSize: 16,
              fontWeight: "bold",
              paddingLeft: 40,
            }}
          >
            {error._items}
          </Typography>
        </Grid>
      ) : null}

      <Grid item xs={12} sm={3} sx={12}>
        <InputField
          name="_discount"
          value={values._discount}
          onChange={(event, newInputValue) =>
            handleChange(event, newInputValue)
          }
          type="text"
          label="Discount"
        />
      </Grid>
      <Grid item xs={12} sm={12} sx={12}>
        <PaymentOptions
          paymentMethods={paymentMethods}
          setPaymentMethods={setPaymentMethods}
          billType={"IMPORT"}
          paymentTypes={[
            { value: "CASH", label: "Cash" },
            { value: "CHEQUE", label: "Cheque" },
            { value: "CREDIT", label: "Credit" },
          ]}
        />
      </Grid>
      <Grid item xs={12} sm={3} sx={12}>
        <InputField
          name="_total"
          value={values._total}
          onChange={(event, newInputValue) =>
            handleChange(event, newInputValue)
          }
          type="text"
          label="Total"
        />

        {/* <Typography variant="subtitle2" gutterBottom component="div">{values._total}</Typography> */}
      </Grid>
      <Grid item xs={12} sm={3} sx={12}>
        <Tooltip title="Calculate">
          <IconButton
            onClick={priceDiscountOperations}
            aria-label="calculate"
            size="small"
          >
            <SyncIcon />
          </IconButton>
        </Tooltip>
      </Grid>
      <Grid item xs={12} sm={9} sx={4}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            size="small"
            label="Bill Date(Optional)"
            value={selectedDate}
            onChange={(date) => {
              setSelectedDate(date);
              const jsDate = date ? date.toDate() : null;
              setBillDate(jsDate);
            }}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} sm={9} sx={12}>
        <InputField
          name="_billNote"
          value={values._billNote}
          onChange={(event, newInputValue) => handleChange(event, newInputValue)}
          type="text"
          label="Note"
          multiline={true}
          rows={4}
        />
      </Grid>
      <Grid item xs={12} sm={12} sx={12}>
        {displayAlert ? (
          <FormAlert type={alertData.type} message={alertData.message} />
        ) : null}
      </Grid>
      <Grid item xs={12} sm={12} sx={12}>
        <Grid container justifyContent="space-between">
          <Grid item xs={12} sm={4} sx={12}>
            <Button fullWidth variant="contained" onClick={submitValue}>
              Create
            </Button>
          </Grid>
          <Grid item xs={12} sm={1} sx={12}>
            <Button onClick={resetValues} variant="outlined">
              Reset
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        {openTable ? (
          <ItemSelectingPopup
            setOpenTable={setOpenTable}
            openTable={openTable}
            handleCloseTable={handleCloseTable}
            setSelectedItems={setSelectedItems}
            selectedItems={selectedItems}
            setRows={setRows}
            rows={rows}
          />
        ) : null}
      </Grid>
    </Grid>
  );
}

export default Im_addBill;
